import { GroupWithUsers } from '@app/core/types/users';
import { GroupActionPermissionsView } from '@app/modules/admin/components/actions-permissions/GroupActionPermissionsView';
import { GroupInfo } from './tabs/GroupInfo';
import { GroupPermissionsManager } from './tabs/GroupPermissionsManager';
import { TabKey, useAdminGroupsViewTabs } from './useAdminGroupsViewTabs';

interface Props {
  readonly group: GroupWithUsers;
}

/**
 * Renders the active group-view tab panel based on the `?tab=` query param.
 */
export function AdminGroupsViewTabContent({ group }: Props) {
  const { activeTab } = useAdminGroupsViewTabs(group);

  return (
    <>
      {activeTab === TabKey.INFO && <GroupInfo group={group} />}
      {activeTab === TabKey.PERMISSIONS && <GroupPermissionsManager group={group} />}
      {activeTab === TabKey.ACTIONS_PERMISSIONS && <GroupActionPermissionsView group={group} />}
    </>
  );
}
